import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

import GoogleDocViewer from 'components/google-doc-viewer/google-doc-viewer.component';
import { DOCS } from 'constants/docs.constants';

const Policy = () => {
  const params = useParams();
  const [docId, setDocId] = useState<string | null>(null);

  useEffect(() => {
    switch (params.type) {
      case 'privacy': {
        setDocId(DOCS.PRIVACY_POLICY);
        break;
      }
      case 'cookie': {
        setDocId(DOCS.COOKIE_POLICY);
        break;
      }
      default: {
        setDocId(null);
        break;
      }
    }
  }, [params.type]);

  return docId ? <GoogleDocViewer docId={docId} /> : null;
};

export default Policy;
